var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invalid-container"},[_c('img',{attrs:{"src":require('@/assets/qietu/in.png'),"alt":""}}),_c('p',[_vm._v("临时链接已失效")])])}
var staticRenderFns = []

export { render, staticRenderFns }